import { Component, inject, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatCardContent } from "@angular/material/card";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { TranslatePipe } from '@ngx-translate/core';
import { MatCheckbox } from "@angular/material/checkbox";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { CommonModule } from '@angular/common';
import { ParamCursoDataService } from '../../../../../../services/curso/param-curso-data.service';
import { ConfirmaTermoFluxoContinuoService } from '../../../../../../services/curso/confirma-termo-fluxo-continuo.service';
import { aceiteInterface } from '../../../../../../interfaces/curso/termo-aceite-response.interface';
import { Router } from '@angular/router';
import { ConfirmaTermoGratuitoService } from '../../../../../../services/curso/confirma-termo-gratuito.service';
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-termo',
  imports: [
    MatCardContent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioModule,
    CommonModule,
    MatProgressSpinner
],
  templateUrl: './termo.html',
  styleUrl: './termo.css'
})
export class Termo {

  _paramData = inject(ParamCursoDataService)
  _confirmaTermoFluxoContinuo = inject(ConfirmaTermoFluxoContinuoService)
  _confirmaTermoGratuito = inject(ConfirmaTermoGratuitoService)
  _router = inject(Router)

  scroll_finished = true

  // termoInput: string = '';
  termo: string = '';
  termo_exibir: string = '';
  loading: boolean = false;

  constructor(){

    this.termo = this._paramData.getDataSubmit().pessoa.termo_fluxo as string;
  }

  formGroup: FormGroup = new FormGroup({
    aceito: new FormControl(false)
  });

  get aceite() {

    return this.formGroup.get('aceito')?.value
  }

  finalizar() {

    if(this._paramData.cursoGratuito && this._paramData.fluxo_continuo == false){

      this.confirma_curso_gratuito();
    }else{

      this.confirma_fluxo_continuo();
    }
  }

  private confirma_curso_gratuito(){

    this.loading = true;

    this._confirmaTermoGratuito.confirmarTermoGratuito(
      this._paramData.getDataSubmit().pessoa.DI_SIGLA,
      this._paramData.getDataSubmit().pessoa.DI_NOFER,
      this._paramData.getDataSubmit().pessoa.PF_RG,
      this.formGroup.get('aceito')?.value == "true" ? true : false
    ).subscribe({

      next: (response: aceiteInterface) => {

        this.loading = false;

          if(response.aceite === "NÃO" ){

            this._paramData.cusroCancelado = true;
            this._router.navigate(['termo-nao-aceito']);
          }else if(response.aceite === "SIM" && this._paramData.curso_sem_taxa === false){

            this._paramData.cusroCancelado = false;
            this._router.navigate(['boleto']);
          }else if(response.aceite === "SIM" && this._paramData.curso_sem_taxa === true){

            this._paramData.cusroCancelado = false;
            this._router.navigate(['/curso-cadastrado-sucesso/info']);
          }
      }

    });
  }

  private confirma_fluxo_continuo(){

    this.loading = true;

    this._confirmaTermoFluxoContinuo.confirmarTermoFluxoContinuo(
      this._paramData.getDataSubmit().pessoa.DI_SIGLA,
      this._paramData.getDataSubmit().pessoa.DI_NOFER,
      this._paramData.getDataSubmit().pessoa.PF_RG,
      this.formGroup.get('aceito')?.value == "true" ? true : false
    ).subscribe({

      next: (response: aceiteInterface) => {

        if(response.aceite === "NAO" ){

          this._paramData.cusroCancelado = true;
          this.loading = false;
          this._router.navigate(['curso-cadastrado-sucesso/termo-nao-aceito']);
        }else{

          this._paramData.cusroCancelado = false;
          this._paramData.urlBoleto = response.urlBoleto;
          this.loading = false;
          this._router.navigate(['curso-cadastrado-sucesso/info']);
        };
      },
      error: (error) => {

        this.loading = false;
        console.log(error);
      }
    })

  }

}
